import { ApiACLRole, ApiReportResponse } from "@incendium/api";
import { Delete, Edit, Star, StarBorder } from "@mui/icons-material";
import {
  Button,
  IconButton,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@mui/material";
import AccessLevel from "Components/AccessLevel/AccessLevel";
import SpacedList, { SpacedLinkButton } from "Components/UI/SpacedList";
import { friendlyDate } from "Helpers/dates";

interface IReportsListProps {
  onClick: () => void;
  onOpen: (id: number) => void;
  onEdit: (id: number) => void;
  reports: ApiReportResponse[];
  onDelete: (r: ApiReportResponse) => void;
  onFavourite: (r: ApiReportResponse) => void;
}

function ReportsList({
  onClick,
  reports,
  onDelete,
  onOpen,
  onEdit,
  onFavourite,
}: IReportsListProps) {
  return (
    <SpacedList
      title="Custom Reports List"
      action={
        <AccessLevel role={ApiACLRole.ANALYTICS_ADMIN} write>
          <Button onClick={onClick}>Create New Report</Button>
        </AccessLevel>
      }
    >
      <TableHead>
        <TableRow>
          <TableCell>Name</TableCell>
          <TableCell>Created On</TableCell>
          <AccessLevel role={ApiACLRole.ANALYTICS_ADMIN} write>
            <TableCell sx={{ width: 140 }}></TableCell>
          </AccessLevel>
        </TableRow>
      </TableHead>

      <TableBody>
        {reports.map((report) => {
          return (
            <TableRow key={report.id}>
              <TableCell className="primary">
                <SpacedLinkButton onClick={() => onOpen(report.id!)}>
                  {report.name}
                </SpacedLinkButton>
              </TableCell>
              <TableCell>{report.createdAt ? friendlyDate(report.createdAt) : "-"}</TableCell>
              <AccessLevel role={ApiACLRole.ANALYTICS_ADMIN} write>
                <TableCell align="right" >
                  <IconButton
                    size="small"
                    color="secondary"
                    onClick={() => onFavourite(report)}
                  >
                    {report.favourite ? <Star /> : <StarBorder />}
                  </IconButton>
                  <IconButton
                    size="small"
                    color="secondary"
                    onClick={() => onEdit(report.id!)}
                  >
                    <Edit />
                  </IconButton>
                  <IconButton
                    size="small"
                    color="secondary"
                    onClick={() => onDelete(report)}
                  >
                    <Delete />
                  </IconButton>
                </TableCell>
              </AccessLevel>
            </TableRow>
          );
        })}
      </TableBody>
    </SpacedList>
  );
}

export default ReportsList;
